module.exports = __webpack_public_path__ + "static/img/main_product.078d713.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/atmosphere-mask/images/main_product.png
// module id = VTvB
// module chunks = 0